/* Base translations · Notifications — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): notifications. */
export const I18N_BASE_NOTIFICATIONS = {
  en: {
    notifications: {
      title: "Notifications",
      markAllRead: "Mark all read",
      empty: "No notifications yet. Long-running uploads and sign-offs will show up here.",
    },
  },
  ar: {
    notifications: {
      title: "الإشعارات",
      markAllRead: "تحديد الكل كمقروء",
      empty: "لا توجد إشعارات بعد. ستظهر هنا عمليات الرفع الطويلة وعمليات التوقيع.",
    },
  },
};

export default I18N_BASE_NOTIFICATIONS;
